import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

const initialState = {
  unauthorized: true,
  loading: false,
  category_arr: false,
  categoryArray: [],
  card_summary: false,
  analytic_card: false,
  data: [],
  error: "",
};

const url = `${BASE_URL}/service`;
const url_setting = `${BASE_URL}/settings`;

const token = localStorage.getItem("token"); 

const config = {
  headers: {
    Authorization: `Token ${token}`,
    // "content-type": "multipart/form-data",
  },
};
const config2 = {
  headers: {
    Authorization: `Token ${token}`,
    "content-type": "multipart/form-data",
  },
};

 

export const fetchMaterialList = createAsyncThunk(
  "fetch/fetchMaterialList",
  async () => {
    return axios
      .get(`${url}/materialLibrary/`, config)
      .then((response) => response.data);
  }
);

export const updateMaterial = createAsyncThunk(
  "update/updateMaterial",
  async (formData) => {
    const cUrl = `${url}/materialLibrary/`;
    return axios
    .put(cUrl, formData, config)
    .then((response) => response.data
    );
  }
);

export const createMaterial = createAsyncThunk(
  "post/createMaterial",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${url}/materialLibrary/`, formData, config);
      return response.data;
    } catch (error) {
      const responseData = error.response?.data;

      return rejectWithValue({
        status: error.response?.status,
        message:
          (typeof responseData === "string" && responseData) ||
          responseData?.message ||
          responseData?.Message ||
          error.message ||
          "Unable to create material.",
      });
    }
  }
);

export const deleteMaterial = createAsyncThunk(
  "delete/deleteMaterial",
  async (formData) => {
    console.log(formData)
    console.log(config)
    return axios
      .delete(`${url}/materialLibrary/?textId=${formData.textId}`,  config)
      .then((response) => formData);
  }
);




export const fetchInterestedCategories = createAsyncThunk(
  "fetch/fetchInterestedCategories",
  async () => {
    return axios
      .get(`${url_setting}/interestedCategoriesManagement/`, config)
      .then((response) => response.data);
  }
);

export const updateInterestedCategories = createAsyncThunk(
  "update/updateInterestedCategories",
  async (formData) => {
    const cUrl = `${url_setting}/interestedCategoriesManagement/`;
    return axios
    .put(cUrl, formData, config2)
    .then((response) => response.data
    );
  }
);

export const createInterestedCategories = createAsyncThunk(
  "post/createInterestedCategories",
  async (formData) => { 
    return axios
      .post(`${url_setting}/interestedCategoriesManagement/`, formData, config2)
      .then((response) => response.data);
  }
);

export const deleteInterestedCategories = createAsyncThunk(
  "delete/deleteInterestedCategories",
  async (formData) => { 
    return axios
      .delete(`${url_setting}/interestedCategoriesManagement/?textId=${formData.textId}`,  config)
      .then((response) => formData);
  }
);


export const fetchInterestedCategoryAnalytic = createAsyncThunk(
  "fetch/fetchInterestedCategoryAnalytic",
  async (categoryId) => {
    return axios
      .get(`${url_setting}/interestedCategory/analytics/${categoryId}/`, config)
      .then((response) => response.data);
  }
);
 

const materialSlice = createSlice({
  name: "identity",
  initialState,
  reducers: {
    updateBellCount(state, action) {
      state.count = state.count + 1;
      // console.log('bell count incrememt!!')
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMaterialList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMaterialList.fulfilled, (state, action) => {
      state.loading = false;

      //  console.log(action.payload)
      state.data = action.payload.materials;
      state.category_arr = action.payload.category_arr;
      // state.Identity_category= action.payload.Identity_category;
      state.error = "";
    });
    builder.addCase(fetchMaterialList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(createMaterial.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createMaterial.fulfilled, (state, action) => {
      state.loading = false;

      console.log(action.payload)
      state.data.push(action.payload.results);
      state.error = "";
    });
    builder.addCase(createMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error;
    });

    builder.addCase(updateMaterial.pending, (state) => {
      state.loading = true;
      console.log('updating...');
    });
    builder.addCase(updateMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.data[action.payload.results.localData] = action.payload.results;
      state.error = "";
      console.log('updatied... ',action.payload);
    });
    builder.addCase(updateMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(deleteMaterial.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteMaterial.fulfilled, (state, action) => {
      state.loading = false;
      state.data.splice(action.payload.localData, 1);
      state.error = "";
    });
    builder.addCase(deleteMaterial.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });


    builder.addCase(fetchInterestedCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchInterestedCategories.fulfilled, (state, action) => {
      state.loading = false; 
      state.data = action.payload.materials;
      state.categoryArray = action.payload.interestedCategoryArray;
      state.category_arr = action.payload.existItemArray;
      state.card_summary = action.payload.category_card_summary;
      state.error = "";
    });
    builder.addCase(fetchInterestedCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(createInterestedCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createInterestedCategories.fulfilled, (state, action) => {
      state.loading = false;
      const createdCategory = action.payload.results || action.payload;
      state.categoryArray.push(createdCategory);
      state.error = "";
    });
    builder.addCase(createInterestedCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(updateInterestedCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateInterestedCategories.fulfilled, (state, action) => {
      state.loading = false;
      const updatedCategory = action.payload.results || action.payload;
      const localData = updatedCategory.localData;
      const categoryIndex = localData !== undefined && localData !== null
        ? localData
        : state.categoryArray.findIndex((item) => item.textId === updatedCategory.textId);

      if (categoryIndex > -1) {
        state.categoryArray[categoryIndex] = updatedCategory;
      }
      state.error = "";
    });
    builder.addCase(updateInterestedCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(deleteInterestedCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteInterestedCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryArray.splice(action.payload.localData, 1);
      state.error = "";
    });
    builder.addCase(deleteInterestedCategories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

    builder.addCase(fetchInterestedCategoryAnalytic.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchInterestedCategoryAnalytic.fulfilled, (state, action) => {
      state.loading = false;
      state.analytic_card = action.payload.result_set 
      state.error = "";
    });
    builder.addCase(fetchInterestedCategoryAnalytic.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });

  },
});

// export const { updateBellCount } = IdentitySlice.actions;

export default materialSlice.reducer;
